(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/pix-mix/components/pix-mix-view/assets/javascripts/pix-mix-image.js') >= 0) return;  svs.modules.push('/modules/pix-mix/components/pix-mix-view/assets/javascripts/pix-mix-image.js');
"use strict";

var _svs$pix_mix$data;

const {
  Image
} = svs.content.image_v2;
const {
  image: cmsImage
} = ((_svs$pix_mix$data = svs.pix_mix.data) === null || _svs$pix_mix$data === void 0 ? void 0 : _svs$pix_mix$data.initialState) || {};
const PixMixImage = () => {
  const image = {
    typeName: 'c_1528119984636',
    aspectRatio: {
      width: cmsImage.width,
      height: cmsImage.height
    },
    width: cmsImage.width,
    height: cmsImage.height,
    url: cmsImage.url,
    altText: 'Pix-mix logotyp',
    availableWidths: [320, 480, 640, 800, 960, 1040, 1120, 1200, 1280],
    availableFormats: [{
      mimetype: 'image/webp',
      extension: '.webp'
    }, {
      mimetype: 'image/jpeg',
      extension: '.jpg'
    }],
    versionLabel: '1.0'
  };
  return React.createElement("div", {
    className: "pix-mix-image-container",
    style: {
      width: cmsImage.width
    }
  }, React.createElement(Image, {
    image: image
  }));
};
setGlobal('svs.pix_mix.components.pixmixView.PixMixImage', PixMixImage);

 })(window);